import React, {useEffect} from 'react';
import { cache } from './global';
// import { extractErrorMessage, showlog, getLastElementOr, emoj, EMOJ } from "@liparistudios/js-utils";
import {WelcomePage} from "./pages/welcome/welcome-page";
import {getLastElementOr} from "./utils";
import {OrdersPage} from "./pages/orders-page/orders-page";
import {VersionPage} from "./pages/version-page/version-page";
import { OrdersPageV2 } from './pages/orders-page-v2/orders-page-v2';
import {Login} from "./pages/login/Login";
import {checkAuth} from "./business-logic/login";
import {DatabasesPage} from "./pages/databases-page/databases-page";
import {CompaniesPage} from "./pages/companies-page/companies-page";
import {AppSettingsPage} from "./pages/app-settings-page/app-settings-page";


window.addEventListener('popstate', (event: any) => {
    cache.currentPageData = event.state.data;
    console.log('Navigation State');
    console.log(event.state);
    debugger;
});

window.addEventListener('PopState', (event: any) => {
    cache.currentPageData = event.state.data;
    console.log('Navigation State');
    console.log(event.state);
    debugger;
});


export type RouteType = {
    id: string;
    label: string;
    icon: string | HTMLImageElement | undefined;
    url: string;
    path: string[];
    component: any;
};

// @ts-ignore
export const routes: RouteType[] = [
    {
        id: 'welcome',
        label: 'welcome',
        icon: '/imgs/logo.png',
        url: '/',
        path: ['/'],
        component: (() => <WelcomePage/>)
    },
    {
        id: 'orders',
        label: 'Ordini',
        icon: '/imgs/stack_box_square.png',
        url: '/orders',
        path: ['/', 'orders'],
        component: (() => <OrdersPage/>)
    },
    {
        id: 'orders-v2',
        label: 'Ordini v2',
        icon: '/imgs/stack_box_square.png',
        url: '/orders-v2',
        path: ['/', 'orders-v2'],
        component: (() => <OrdersPageV2/>)
    },
    {
        id: 'version',
        label: 'Versioni',
        icon: '/imgs/calendar_30000.png',
        url: '/version',
        path: ['/', 'version'],
        component: (() => (<VersionPage/>))
    },
    {
        id: 'login',
        label: 'Login',
        icon: '/imgs/calendar_30000.png',
        url: '/login',
        path: ['/', 'login'],
        component: (() => (<Login/>))
    },
    {
        id: 'databases',
        label: 'Database',
        icon: '/imgs/database.png',
        url: '/databases',
        path: ['/', 'databases'],
        component: (() => <DatabasesPage />)
    },
    {
        id: 'companies',
        label: 'Aziende',
        icon: '/imgs/customers_2.png',
        url: '/companies',
        path: ['/', 'companies'],
        component: (() => <CompaniesPage />)
    },
    {
        id: 'app-settings',
        label: 'Impostazioni App',
        icon: '/imgs/impostazioni.png',
        url: '/app-settings',
        path: ['/', 'app-settings'],
        component: (() => <AppSettingsPage />)
    },
    {
        id: 'error',
        label: 'Errore',
        icon: 'cash.png',
        url: '/err',
        path: ['/', 'err'],
        component: () => (
            <div
                style={{
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'flex-start'
                }}
            >
                <span>Qualcosa e andato storto</span>
                <pre className={'error-message-content'} style={{ flexDirection: 'column' }}>
                    <label>Errore: </label>
                    <code>
                        {
                            // emoj(EMOJ.thinking_face) +' '+ extractErrorMessage(cache.currentPageData)
                        }
                    </code>
                </pre>
            </div>
        )
    }
];


export const router = () => {
    let route: RouteType = (
        routes
            .filter((route: any) => route.url === window.location.pathname)
            .reduce(getLastElementOr, routes[0])
    );
    if (!checkAuth()) route = routes.find(({id}: RouteType) => id === "login") || routes[0]
    window.history.pushState(window.history.state || cache.currentPageData || {}, route.label, route.url); // serve perche se l'url non e valido almeno viene portato ad un url valido
    cache.currentPage = route;
    return route;
}

export const navigateTo = (routeID: string, data?: any): any => {
    let route: RouteType = (
        routes
            .filter((route: RouteType) => route.id === routeID)
            .reduce(getLastElementOr, routes[0])
    );
    window.history.pushState(data || {}, route.label, route.url);
    cache.currentPage = route;
    cache.currentPageData = data;  // ridondante, eprche gia avviene in App.tsx, e poi in realta credo che non serva
    return route.component;
}


export const routeTo = (url: string, state?: any) => {
    let route: RouteType = (
        routes
            .filter((route: RouteType) => route.url === url)
            .reduce(getLastElementOr, {
                id: '',
                label: '',
                icon: undefined,
                url: '',
                path: [],
                component: undefined
            })
    );

    if( !route || !route.component ) {
        // TODO da sistemare
        window.location.href = url;
    }
    else {
        window.history.pushState(state || {}, route.label, route.url);
        cache.currentPage = route;
        return route.component;
    }
}
